module.exports = __webpack_public_path__ + "img/purple-circle-table-10.c16bbca2.png";